import { Observable } from 'rxjs';

import { isPresent } from '@fcom/core/utils';

export const fileToBase64 = (file: File): Observable<string> => {
  return new Observable<string>((observer) => {
    const reader = new FileReader();
    reader.onload = () => {
      observer.next(reader.result?.toString());
      observer.complete();
    };
    reader.onerror = (err) => {
      observer.error(err);
    };
    reader.readAsDataURL(file);
  });
};

export const formatDateInput = (dateString: string): string => {
  if (/[^\d.]/.test(dateString) || dateString.length === 1) {
    return dateString;
  }

  const dateParts = dateString.split('.');
  const [day, month, year] = dateParts;

  if (dateParts.length > 3) {
    return dateString;
  }

  if (day?.length > 2) {
    return dateString;
  }

  const resultParts: string[] = [];

  const dayValue = parseInt(day, 10);

  if (!isNaN(dayValue) && dayValue >= 1 && dayValue <= 9 && (dateParts.length > 1 || dateString.endsWith('.'))) {
    resultParts.push('0' + dayValue);
  } else {
    resultParts.push(day);
  }

  if (dateParts.length === 1 && !dateString.endsWith('.') && !isNaN(dayValue) && dayValue >= 1 && dayValue <= 31) {
    resultParts.push('');
  } else if (isPresent(month)) {
    if (month.length > 2) {
      return dateString;
    }

    const monthValue = parseInt(month, 10);

    if (!isNaN(monthValue) && monthValue >= 1 && monthValue <= 9 && dateParts.length === 3) {
      resultParts.push('0' + monthValue);
    } else {
      resultParts.push(month);
    }

    if (
      dateParts.length === 2 &&
      !dateString.endsWith('.') &&
      month.length === 2 &&
      !isNaN(monthValue) &&
      monthValue >= 1 &&
      monthValue <= 12
    ) {
      resultParts.push('');
    }
  }

  if (year !== undefined) {
    if (year.length > 4) {
      resultParts.push(year.substring(0, 4));
    } else {
      resultParts.push(year);
    }
  }

  return resultParts.join('.');
};
